import {
  SiBluesky,
  SiInstagram,
  SiYoutube,
} from "@icons-pack/react-simple-icons";
import Link from "astro-typesafe-routes/link/react";
import type { IPinfo } from "node-ipinfo";
import { use } from "react";

import { IPinfoContext } from "../IPinfoContext";
import { FooterNav } from "./FooterNav";

export const Footer: React.FC<{ ipInfo?: IPinfo | null }> = ({
  ipInfo = use(IPinfoContext),
}) => {
  return (
    <footer className="border-t bg-base-200 text-sm">
      <div className="divide-y wrap pad">
        <nav className="auto-cols-fr grid-flow-col gap-4 max-md:divide-y md:grid md:gap-6 md:py-12">
          <FooterNav title="Word games">
            <Link to="/play">Play now</Link>
            <Link to="/packs">Browse packs</Link>
            <Link to="/packs/original">Original packs</Link>
            <Link to="/collections">Browse collections</Link>
            <a href="https://shop.knoword.com">Shop merch</a>
          </FooterNav>
          <FooterNav title="Teaching tools">
            <Link to="/teachers">Knoword for Teachers</Link>
            <Link to="/pricing">Pricing information</Link>
            <Link to="/teachers/vocabulary-games">Vocabulary Games</Link>
            <Link to="/teachers/science-of-reading">
              The Science of Reading
            </Link>
            <Link to="/teachers/sat-prep">SAT Prep</Link>
          </FooterNav>
          <div className="max-md:divide-y md:space-y-6">
            <FooterNav title="Support & resources">
              <Link to="/support/contact">Contact us</Link>
              <Link to="/support/faq">FAQ</Link>
              <Link to="/support/guides">Guides</Link>
              <Link to="/blog">Blog</Link>
            </FooterNav>
            <FooterNav title="Compare">
              <Link to="/knoword-vs-quizlet">vs. Quizlet</Link>
            </FooterNav>
          </div>
        </nav>
        <div className="flex items-center justify-between gap-4 py-6 max-md:flex-col-reverse md:gap-2">
          <div className="flex gap-1.5">
            <span>
              &copy; {new Date().getFullYear()}{" "}
              <span className="max-sm:hidden">Knoword</span>
            </span>
            &middot;
            <Link className="link-hover link" to="/privacy">
              Privacy <span className="max-sm:hidden">Policy</span>
            </Link>
            &middot;
            <Link className="link-hover link" to="/terms">
              Terms <span className="max-sm:hidden">of Service</span>
            </Link>
            {ipInfo?.countryCode !== "US" && (
              <>
                &middot;
                <span>Made in 🇨🇦</span>
              </>
            )}
          </div>
          <div className="flex gap-4">
            <a
              href="https://youtube.com/@PlayKnoword"
              target="_blank"
              rel="noopener noreferrer"
            >
              <SiYoutube className="size-5" />
            </a>
            <a
              href="https://instagram.com/playknoword"
              target="_blank"
              rel="noopener noreferrer"
            >
              <SiInstagram className="size-5" />
            </a>
            <a
              href="https://bsky.app/profile/knoword.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <SiBluesky className="size-5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
